import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from "react-router";
import {changePasswordService} from "../services/employee";
import {AxiosError} from "axios";
import {Msg} from "./ForgotPassword";
import Label from "../components/Label";
import Input from "../components/input/InputField";
import Button from "../components/button/Button";
import AuthLayout from "../components/AuthPageLayout";
import {LuEye} from "react-icons/lu";
import {TbEyeClosed} from "react-icons/tb";

const ChangePassword = () => {
    const { token } = useParams();

    const navigate = useNavigate();

    const [password, setPassword] = useState<string>("");
    const [rePassword, setRePassword] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [errors, setError] = useState<string>("");
    const [success, setSuccess] = React.useState("");

    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setReShowPassword] = useState(false);

    useEffect(() => {
        setInterval(() => {
            if (success) {
                navigate("/login", { replace: true });
                return;
            }
            if (!token) {
                setError("Token is required");
                return;
            }

            try {
                changePasswordService(token, password).then();
            } catch (error) {
                if (error instanceof AxiosError) {
                    setError(error.response?.data?.error);
                    return;
                }
                setError("Something went wrong!");

            }


        }, 300000);
    }, [token]);

    const  submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        setError("");

        if (password.length < 8 ) {
            setError("Passwords is too short");
            setLoading(false);
            return;
        }

        if (password !== rePassword) {
            setError("Passwords don't match");
            setLoading(false);
            return;
        }

        if (!token) {
            setError("Token is required");
            setLoading(false);
            return;
        }

        try {
            const result = await changePasswordService(token, password);
            // console.log(result)
            const data: Msg = result.data;
            setSuccess(data.msg);
            navigate("/login", { replace: true });

            // console.log(result.data)
        } catch (error) {
            // if (error) {
            //     // @ts-ignore
            //     setError(error.response.data.error);
            //     return;
            // }
            if (error instanceof AxiosError) {
                setError(error.response?.data?.error);
                setLoading(false);
                return;
            }
            setError("Something went wrong!");

        }

    }

    return (
        <AuthLayout>
            <div className="flex flex-col flex-1">

                <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
                    <div>
                        <div className="mb-5 sm:mb-8">
                            {
                                errors.length > 0 && (
                                    <small className={`px-2 py-1.5 ring-1 ring-red-500 bg-red-300/70 rounded-md text-red-500`}>{errors}</small>
                                )
                            }
                            {
                                success.length > 0 && (
                                    <div className={`w-full h-fit mt-4 bg-emerald-500/20 rounded-sm`}>
                                        <p className={`w-full text-center px-2 py-1.5  ring-1 ring-emerald-500 text-sm text-emerald-500 font-semibold rounded-sm`}>{success}</p>
                                    </div>
                                )
                            }
                            <h1 className="mb-2 text-xl md:text-2xl lg:text-4xl max-lg:text-center font-semibold text-gray-800 text-title-smcsm:text-title-md">
                                Change Your Password!
                            </h1>
                            <div className="lg:hidden flex flex-col items-center justify-center w-full mb-2">
                                <Link to="/" className="block">
                                    <img
                                        width={231}
                                        height={48}
                                        src="https://kmcwebsite.nyc3.cdn.digitaloceanspaces.com/assets/images/logo.png"
                                        alt="Logo"
                                    />
                                </Link>
                                {/*<p className="text-center text-gray-900">*/}
                                {/*    Kiira Integrated Information Systems*/}
                                {/*</p>*/}
                            </div>
                            <p className="text-xs md:text-sm max-lg:text-center  text-gray-500">
                                Enter the new password to be linked to your account, and we’ll link to your account.
                            </p>
                        </div>
                        <div>
                            <form onSubmit={submitHandler}>
                                <div className="space-y-4 lg:space-y-6">
                                    <div>
                                        <Label>
                                            New Password <span className="text-red-500">*</span>{" "}
                                        </Label>
                                        <div className="relative">
                                            <Input
                                                name={"password"}
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                type={showPassword ? "text" : "password"}
                                                placeholder="Enter your password"
                                            />
                                            <span
                                                onClick={() => setShowPassword(!showPassword)}
                                                className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                                            >
                                              {showPassword ? (
                                                  <LuEye  className="text-gray-500  size-5" />
                                              ) : (
                                                  <TbEyeClosed className="text-gray-500 size-5" />
                                              )}
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        <Label>
                                            Re-Enter New Password <span className="text-red-500">*</span>{" "}
                                        </Label>
                                        <div className="relative">
                                            <Input
                                                value={rePassword}
                                                name={"re-enter-password"}
                                                onChange={(e) => setRePassword(e.target.value)}
                                                type={showRePassword ? "text" : "password"}
                                                placeholder="Re-Enter your password"
                                            />
                                            <span
                                                onClick={() => setReShowPassword(!showRePassword)}
                                                className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                                            >
                                              {showRePassword ? (
                                                  <LuEye  className="text-gray-500  size-5" />
                                              ) : (
                                                  <TbEyeClosed className="text-gray-500 size-5" />
                                              )}
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        <Button disabled={loading} className="w-full" size="sm">
                                            {loading? "Changing..." : success.length > 0 ? "Change is Done":"Change Password"}
                                        </Button>
                                    </div>
                                    <div className="flex flex-row items-center md:gap-0.5 lg:gap-2 justify-start">
                                        <p className={`max-sm:hidden text-sm`}>Wait, I remember my password...</p>
                                        <Link
                                            to="/login"
                                            className="text-sm text-orange-500 hover:text-orange-600"
                                        >
                                            Let me try again
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </AuthLayout>

        // <div className={`w-full h-full`}>
        //     <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 mt-20">
        //         <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        //             <img
        //                 alt="Your Company"
        //                 src="https://kmcwebsite.nyc3.cdn.digitaloceanspaces.com/new%20logos/Asset%205.webp"
        //                 className="mx-auto h-10 w-auto"
        //             />
        //             <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
        //                 Choose New Password
        //             </h2>
        //             {
        //                 (loading && success.length <= 0) && (
        //                     <p>Loading...</p>
        //                 )
        //             }
        //             {
        //                 error.length > 0 && (
        //                     <div className={`w-full h-fit mt-4 bg-red-500/20 rounded-sm`}>
        //                         <p className={`w-full text-center px-2 py-1.5  ring-1 ring-red-500 text-sm text-red-500 font-semibold rounded-sm`}>{error}</p>
        //                     </div>
        //                 )
        //             }
        //             {
        //                 success.length > 0 && (
        //                     <div className={`w-full h-fit mt-4 bg-emerald-500/20 rounded-sm`}>
        //                         <p className={`w-full text-center px-2 py-1.5  ring-1 ring-emerald-500 text-sm text-emerald-500 font-semibold rounded-sm`}>{success}</p>
        //                     </div>
        //                 )
        //             }
        //
        //         </div>
        //
        //         <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        //             <form onSubmit={submitHandler} className="space-y-6">
        //                 <div>
        //                     <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
        //                         Password
        //                     </label>
        //                     <div className="mt-2">
        //                         <input
        //                             onChange={(e) => setPassword(e.target.value)}
        //                             id="password"
        //                             name="password"
        //                             type="password"
        //                             value={password}
        //                             required
        //                             className="block w-full rounded-md border-0 py-1.5 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 outline-0 focus:outline-0 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
        //                         />
        //                     </div>
        //                 </div>
        //
        //                 <div>
        //                     <label htmlFor="rpassword" className="block text-sm font-medium leading-6 text-gray-900">
        //                         Re-Enter Password
        //                     </label>
        //                     <div className="mt-2">
        //                         <input
        //                             onChange={(e) => setRePassword(e.target.value)}
        //                             id="rpassword"
        //                             name="rpassword"
        //                             type="password"
        //                             value={rePassword}
        //                             required
        //                             className="block w-full rounded-md border-0 py-1.5 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  outline-0 focus:outline-0 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
        //                         />
        //                     </div>
        //                 </div>
        //
        //                 <div>
        //                     <button
        //                         disabled={loading}
        //                         type="submit"
        //                         className="flex w-full justify-center rounded-md bg-orange-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
        //                     >
        //                         Change
        //                     </button>
        //                 </div>
        //             </form>
        //
        //
        //             <Link to="/signup">
        //                 <p className="mt-10 text-center text-sm text-gray-500"> Not registered </p>
        //             </Link>
        //
        //         </div>
        //     </div>
        // </div>
    );
};

export default ChangePassword;